'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

/* injects from baggage-loader */

var PROJECTS_DATA = exports.PROJECTS_DATA = 'PROJECTS_DATA';
var PROJECT_DATA = exports.PROJECT_DATA = 'PROJECT_DATA';
var NODE_DATA = exports.NODE_DATA = 'NODE_DATA';


//////////////////
// WEBPACK FOOTER
// ./app/constants/data.js
// module id = 141
// module chunks = 1